import AdminDashboard from './Dashboard';

export default AdminDashboard;


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/Dashboard/index.tsx